import React from 'react';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import s from './DeviationLink.scss';
const getUrl = (url)=>{
    if (!/^http/.test(url)) {
        return `http://${url}`;
    }
    return url;
};
const EditorDeviationLink = ({ link , deviation , linkClass , children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['link']
    }, link ? /*#__PURE__*/ React.createElement("a", {
        href: cleanLinkSrc(getUrl(link.url)),
        rel: "nofollow noopener"
    }, children) : /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        className: linkClass,
        canLinkToStash: deviation.isJournal
    }, children));
};
EditorDeviationLink.displayName = 'EditorDeviationLink';
export default EditorDeviationLink;
